import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchConfig } from "@/lib/api";
import { getRole, setRole as persistRole } from "@/lib/storage";

const AppContext = createContext({ supportEmail: "support@example.com", role: null, setRole: () => {} });

export function AppProvider({ children }) {
  const [supportEmail, setSupportEmail] = useState("support@example.com");
  const [role, setRoleState] = useState(getRole());

  useEffect(() => {
    let active = true;
    fetchConfig()
      .then((cfg) => {
        if (active && cfg?.supportEmail) setSupportEmail(cfg.supportEmail);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const setRole = useCallback((next) => {
    persistRole(next);
    setRoleState(next);
  }, []);

  return (
    <AppContext.Provider value={{ supportEmail, role, setRole }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
